import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";

// Services Library
import { REDUX as REDUX_UTIL, TIME } from "../../services/util";

// styles
import "../index.css";

// Components Library
import {ProfilePage, ProfileSidebar} from './components'

// Redux Library
import * as REDUX_ACTION from "../../services/redux/actions";

const { reduxStoreWrapper } = REDUX_UTIL;

const Profile = () => {
  const dispatch = useDispatch();
  const user = useSelector(reduxStoreWrapper("user"));
  // const companies = useSelector(reduxStoreWrapper("company.byID")) || {};

  return (
    <>
        <div className='container' style={{ border: '0.1em solid', borderColor:'grey' ,borderRadius: '0.5em',flexDirection: 'row', display: 'flex' }}>
            <ProfileSidebar></ProfileSidebar>
            <div style={{ borderLeft: '1px solid grey', height: 'auto', alignSelf: 'stretch' }}></div>
            <ProfilePage></ProfilePage>
        </div>  
    </>
  )
}

export default Profile